import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
      primary: { main: "#fff494" },
      secondary: { main: "#E4D00A" },
    },
    typography: { useNextVariants: true },
  });

  export const pickDays = [ "1", "2", "3","4","5","10","20","30","60" ];

  export const transitDays = Array.from({length : 20 }, (_,index) => index + 1);

  export const currencyPayload = {"EUR":"€","GBP":"£"}